<template>
  <div class="header">
      <div class="left">
          <slot name="back"></slot>
      </div>
      <div class="title">
          <slot name="title"></slot>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  //接收来自父组件的数据
  props: {},
  //生命周期实例创建完成后被立即调用
  created() {},
  //生命周期挂载完成之后被调用
  mounted() {},
  //组件
  components: {},
  //方法
  methods: {},
  //监视
  watch: {}
};
</script>
<style lang="less" scoped>
.header{
    width: 100%;
    height: 88px;
    font-size: 34px;
    background: #2d5ea7;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .left{
        position: absolute;
        top: 22px;
        left: 20px;
        width: 15px;
        height: 26px;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>